// @flow
import Navigation from 'app/pages/SettingsPage/Navigation'; // TODO полностью перенести в pages

export default Navigation;
